import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { alertActions } from '../../../_actions/alert.actions';
import { clientActions } from '../../../_actions/client.actions';
import { clientService } from '../../../_services/client.service';

export default function Services() {
  const dispatch = useDispatch();

  const clientId = useSelector(state => state.client.id);


  const clientServices = useSelector(state => state.client.services);
  const [enabling, setEnabling] = useState(false);

  const handleEnable = () => {
    setEnabling(true);

    clientService.enableIntake()
      .then((services) => {
        setEnabling(false);

        localStorage.setItem('clientServices', JSON.stringify(services))

        dispatch(clientActions.setServices(services))
      })
      .catch(() => {
        setEnabling(false);

        dispatch(alertActions.error("Could not enable AxS Intake. We're looking into it."));
      });
  }

  const conditional = () => {
    if (clientServices.INTAKE.status) {
      return <>
        <h5>Set Up Instructions for Tablets:</h5>
        <ol>
          <li>Open Chrome and navigate to <a href="https://intake.axshealthapp.com">https://intake.axshealthapp.com</a></li>
          <li>Click the "three dots" Icon in the top right hand corner of the Chrome browser.</li>
          <li>Select "Add to Home Screen" from the drop down.</li>
          <li>Use the following "Secret Key" to log in. The "Secret Key" can be used on multiple tablets.</li>
        </ol>

        <dl className="row">
          <dt className="col-md-2">Provider ID:</dt>
          <dd className="col-md-10">{clientId}</dd>

          <dt className="col-md-2">Secret Key:</dt>
          <dd className="col-md-10">{clientServices.INTAKE.payload.secretKey}</dd>
        </dl>
      </>
    } else {
      return <>
        <p className="m-0">AxS Intake allows you to collect patient's info using a tablet in your lobby for those patients that did not complete their AxS Link.</p>
        <p>Using AxS Intake is as easy as setting the home page on any browser to <span className="text-info">https://intake.axshealthapp.com</span> on any tablet.</p>

        <button onClick={handleEnable} disabled={enabling} type="button" className="btn btn-primary">{enabling ? 'Enabling...' : 'Enable AxS Intake'}</button>
      </>
    }
  }

  return <div className="card axs-shadow mt-5">
    <div className="card-body">
      <h1 className="h2 border-bottom pb-2 mb-4">AxS Intake</h1>

      {conditional()}
    </div>
  </div>
}